var map = {
	"./Fax.svg": 64661,
	"./Login/Kundenbereich/Piktogramme_Blau_Lieferung.svg": 95957,
	"./Login/Kundenbereich/avatar-double-confident.svg": 75704,
	"./Mail.svg": 99263,
	"./Pfeil-rechts.svg": 39400,
	"./Standort.svg": 33371,
	"./add-circle.svg": 93266,
	"./addresses.svg": 76546,
	"./alert-circle-orange.svg": 9320,
	"./alert-circle-red.svg": 36679,
	"./alltagshilfen-small.svg": 64192,
	"./apps.svg": 71784,
	"./archive-2.svg": 78415,
	"./archive.svg": 232,
	"./arrow-back.svg": 63079,
	"./arrow-button-right.svg": 91731,
	"./arrow-forward.svg": 49007,
	"./arrow-left.svg": 92233,
	"./arrow-right.svg": 20004,
	"./atemtherapie-small.svg": 89565,
	"./avatar-double-confident.svg": 63202,
	"./avatar-small.svg": 62731,
	"./avatar.svg": 96809,
	"./block.svg": 8363,
	"./bookmark.svg": 61308,
	"./building.svg": 56696,
	"./bullet.svg": 23884,
	"./calendar-add-1-white.svg": 85526,
	"./calendar-add.svg": 9832,
	"./calendar.svg": 67894,
	"./cancel.svg": 73130,
	"./cart-checkout.svg": 84003,
	"./cart.svg": 90158,
	"./chat.svg": 90698,
	"./check-blue.svg": 10495,
	"./check-circle-filled.svg": 71424,
	"./check-circle.svg": 24487,
	"./check.svg": 96702,
	"./checklist.svg": 3958,
	"./chevron-down.svg": 17154,
	"./chevron-left.svg": 95703,
	"./chevron-right.svg": 47498,
	"./chevron-small.svg": 13855,
	"./circle.svg": 42500,
	"./clock-confident.svg": 26101,
	"./clock.svg": 20288,
	"./close.svg": 58810,
	"./contact-page.svg": 46788,
	"./contact.svg": 75906,
	"./cut.svg": 20418,
	"./dashboard-2.svg": 65517,
	"./dashboard.svg": 50530,
	"./delete.svg": 84555,
	"./description.svg": 41092,
	"./download.svg": 57148,
	"./drag.svg": 84906,
	"./duplicate.svg": 51031,
	"./edit.svg": 76180,
	"./envelope.svg": 50664,
	"./facebook.svg": 72748,
	"./favorite.svg": 45056,
	"./feedback.svg": 61363,
	"./filter-list.svg": 32363,
	"./food-small.svg": 19322,
	"./grid-view.svg": 60624,
	"./group.svg": 53409,
	"./home.svg": 13031,
	"./in-progress-0.svg": 32534,
	"./in-progress-10.svg": 97601,
	"./in-progress-25.svg": 28261,
	"./in-progress-65.svg": 72769,
	"./in-progress.svg": 30003,
	"./infektschutz-small.svg": 21180,
	"./info.svg": 82616,
	"./information-circle.svg": 58881,
	"./infusion-small.svg": 6137,
	"./injektion-small.svg": 77697,
	"./instagram.svg": 43450,
	"./kompression-small.svg": 62462,
	"./kontinenz-small.svg": 92606,
	"./kontinenz.svg": 56280,
	"./laptop-confident.svg": 90533,
	"./letter.svg": 47504,
	"./linkedin.svg": 49742,
	"./listbullets.svg": 90155,
	"./logo/facebook.svg": 39154,
	"./medi-small.svg": 13743,
	"./migel-nok.svg": 63593,
	"./migel-ok.svg": 27483,
	"./minus.svg": 61126,
	"./navigation-menu.svg": 78216,
	"./notifications.svg": 2374,
	"./ops.svg": 74402,
	"./order-check.svg": 34847,
	"./oval.svg": 48824,
	"./package.svg": 49706,
	"./passkey.svg": 75214,
	"./patient-list.svg": 1835,
	"./patient.svg": 65095,
	"./pdf.svg": 93304,
	"./pending.svg": 54273,
	"./person-cancel.svg": 23436,
	"./phone-time.svg": 46078,
	"./phone.svg": 45958,
	"./pin-small.svg": 64555,
	"./pin.svg": 86441,
	"./playlist-add.svg": 8580,
	"./plus.svg": 65376,
	"./prescription-2.svg": 17407,
	"./prescription.svg": 60088,
	"./print.svg": 17669,
	"./push-pin.svg": 48222,
	"./release-alert.svg": 51680,
	"./restart.svg": 25521,
	"./road-sign-warning.svg": 691,
	"./search.svg": 51308,
	"./send.svg": 9934,
	"./sentiment-neutral.svg": 67285,
	"./settings.svg": 21349,
	"./shipment-nok.svg": 51231,
	"./shipment-not-possible.svg": 16752,
	"./shipment-ok.svg": 58089,
	"./splitscreen.svg": 38678,
	"./stoma-small.svg": 80846,
	"./target.svg": 91837,
	"./tracheo-small.svg": 52974,
	"./truck.svg": 4517,
	"./uncut.svg": 77139,
	"./upload.svg": 43953,
	"./user-attributes.svg": 6009,
	"./verbrauchsmaterial-small.svg": 35090,
	"./visibility-off.svg": 39136,
	"./visibility-on.svg": 38740,
	"./vital-small.svg": 72370,
	"./wund-small.svg": 17140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24431;